import { MenuItem, TextField, useTheme } from '@mui/material';
import { useState } from 'react';
import { COUNTRIES } from '../../constants';

const CountriesSelect = ({
  countries,
  component: Component = TextField,
  ...props
}) => {
  const theme = useTheme();
  const topCountriesLength = COUNTRIES.TOP_COUNTRIES.length;
  const inputId = `${props.name}-input`;
  const [open, setOpen] = useState(false);

  return (
    <Component
      {...props}
      id={props.name}
      slotProps={{
        htmlInput: {
          id: inputId,
          role: 'combobox',
          'aria-expanded': open,
          'aria-controls': `menu-${props.name}`,
        },
        input: {
          'aria-label': props.id,
        },
        select: {
          onOpen: () => setOpen(true),
          onClose: () => setOpen(false),
        },
      }}
      autoComplete='off'
    >
      {countries.map(({ countryKey, countryName } = {}, index) => (
        <MenuItem
          key={countryKey}
          value={countryKey}
          id={`${props.name}-option-${countryKey}`}
          role='option'
          aria-selected={props.value === countryKey}
          divider={index === topCountriesLength - 2}
          sx={{
            '&.MuiMenuItem-divider': {
              borderBottom: `1px dashed ${theme.palette.info.light}`,
              my: 1,
            },
          }}
        >
          {countryName}
        </MenuItem>
      ))}
    </Component>
  );
};

export default CountriesSelect;
